<div class="icon">
  <div
    class="circle-ripple"
    [ngClass]="{
      error: status === 'error',
      success: status === 'success'
    }"
  >
    <span ngClass="{{'cidaas-icon-'+type}}"></span>
  </div>
</div>
